import { render } from "./AvioBoschung.vue?vue&type=template&id=28e9d9bc&scoped=true"
import script from "./AvioBoschung.vue?vue&type=script&lang=js"
export * from "./AvioBoschung.vue?vue&type=script&lang=js"

import "./AvioBoschung.vue?vue&type=style&index=0&id=28e9d9bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e9d9bc"]])

export default __exports__